import Raven from 'raven-js'

const identity = stuff => stuff
// we use hashmap to quickly search for ignoredActions
const ignoredActions = {
  '@@redux-form/REGISTER_FIELD': true,
  '@@redux-form/UNREGISTER_FIELD': true,
  '@@redux-form/DESTROY': true,
  'PAGE_SHOW_LOADING_SPINNER': true,
  'SHOW_PROGRESS_BAR': true,
  'HIDE_PROGRESS_BAR': true
}

/**
  Function that generates a crash reporter for Sentry.
  @param dsn - private Sentry DSN.
  @param cfg - object to configure Raven.
  @param options - customize extra data sent to sentry
    actionTransformer - tranform the action object to send; default to identity function
    stateTransformer - transform the state object to send; default to identity function
    logger - the logger to use for logging; default to console.error
*/
export default function createMiddleware (dsn, cfg = {}, options = {}) {
  const MAX_PAYLOAD_LENGTH = 500

  if (!Raven.isSetup()) {
    if (!dsn) {
      // Skip this middleware if there is no DSN.
      console.error('[redux-raven-middleware] Sentry DSN required.')
      return store => next => action => {
        next(action)
      }
    }
    Raven.config(dsn, cfg).install()
  }

  return store => next => action => {
    const {
      actionTransformer = identity,
      stateTransformer = identity,
      logger = console.error.bind(console, '[redux-raven-middleware] Reporting error to Sentry:')
    } = options
    try {
      let payload
      if (typeof action.payload === 'object') {
        payload = JSON.stringify(action.payload).substr(0, MAX_PAYLOAD_LENGTH)
      } else {
        payload = action.payload
      }
      if (!ignoredActions[action.type]) {
        Raven.captureBreadcrumb({
          category: 'redux',
          message: action.type,
          data: {...action, payload}
        })
      }
      return next(action)
    } catch (err) {
      logger(err)

      // Send the report.
      Raven.captureException(err, {
        extra: {
          action: actionTransformer(action),
          state: stateTransformer(store.getState())
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./app/middleware/redux.sentry.middleware.js